import { render, staticRenderFns } from "./right-index.vue?vue&type=template&id=f551129c&scoped=true"
import script from "./right-index.vue?vue&type=script&lang=js"
export * from "./right-index.vue?vue&type=script&lang=js"
import style0 from "./right-index.vue?vue&type=style&index=0&id=f551129c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f551129c",
  null
  
)

export default component.exports